export enum JobStatus {
    Unknown,
    Awaiting,
    Deleted,
    Enqueued,
    Failed,
    Processing,
    Scheduled,
    Succeeded
}